import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from '../shared/CTAButton';
import { Reveal } from '../shared/Section';
const perks = ['6 módulos de conocimiento para transformar tu movilidad', 'Guía de Estiramientos Completos por Tiempo incluida de regalo', 'Rutina Anti-tensión para Cuello y Trapecios de regalo', 'Checklist de Progreso Semana a Semana de regalo'];
export function FinalCTA() {
  return <section className="w-full bg-sand-200/60 px-5 py-16 sm:py-24" data-id="element-59" data-mp="3drsgzdoo34xv">
      <Reveal data-id="element-60" data-mp="3hvqgvqltgjrz">
        <div className="mx-auto max-w-2xl text-center" data-id="element-61" data-mp="3hvgtmas5oqpz">
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-forest-800 sm:text-4xl md:text-[2.75rem]" data-id="element-62" data-mp="33v5ygvjtcpz0">
            Tu cuerpo puede moverse sin dolor. Empezá hoy.
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-base leading-relaxed text-forest-700/70 sm:text-lg" data-id="element-63" data-mp="1239o3p9dtm5t">
            Dejá de buscar la solución complicada. La más simple y efectiva ya está esperándote.
          </p>

          <ul className="mx-auto mt-8 grid max-w-md gap-3 text-left" data-id="element-64" data-mp="q7lmnqxnd742">
            {perks.map(p => <li key={p} className="flex items-start gap-3 text-sm text-forest-700/85" data-id="element-65" data-mp="l8r32mruveiw">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay-500" strokeWidth={3} data-id="element-66" data-mp="yzvxnagd9gmd" />
                {p}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-67" data-mp="79rhjnzn3fqy">
            <CTAButton size="lg" data-id="element-68" data-mp="7ass7rcqu085">VER OFERTA Y PRECIO</CTAButton>
          </div>

          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-forest-700/60" data-id="element-69" data-mp="2b7rpchxdjtb">
            <LockIcon className="h-4 w-4" data-id="element-70" data-mp="gaz1t25bmg21" />
            Pago con Mercado Pago · Garantía de devolución de 30 días
          </p>
        </div>
      </Reveal>
    </section>;
}